"use client"

import { useEffect } from "react"

export default function ISOPageRedirect() {
  useEffect(() => {
    // Replace current history entry so back goes to previous page (like home)
    window.location.replace("/CERTS/ISO_Cert.pdf")
  }, [])

  return null // No need to render anything
}
